enum ShareType {
    share,
    copy,
    outlook,
    nonOutlook,
    moreApps,
    teams
}

export default ShareType;